import React from 'react';
import { Box, Grid, TextField, InputAdornment, Select, MenuItem } from '@material-ui/core';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import ClearAllRoundedIcon from '@material-ui/icons/ClearAllRounded';

const TYPE_OPTIONS = [
    { value: 'release', label: 'Release' },
    { value: 'announcement', label: 'Announcement' },
    { value: 'system_alert', label: 'System Alert' }
];

const STATUS_OPTIONS = [
    { value: 'all', label: 'All Status' },
    { value: 'read', label: 'Read' },
    { value: 'unread', label: 'Unread' }
];

const NotificationToolbar = ({ searchValue, onSearchChange, typeFilter, onTypeFilterChange, statusFilter, onStatusFilterChange, onClearFilters }) => (
    <Box className="notification-page-toolbar">
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6} md={6} style={{ minWidth: 0 }}>
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={searchValue}
                    onChange={(event) => onSearchChange(event.target.value)}
                    placeholder="Search notifications..."
                    InputProps={{ startAdornment: <InputAdornment position="start"><SearchRoundedIcon /></InputAdornment> }}
                    className="notification-page-search-field"
                />
            </Grid>
            <Grid item xs={12} sm={3} md={2}>
                <Select variant="outlined" size="small" fullWidth value={typeFilter} onChange={(event) => onTypeFilterChange(event.target.value)} className="notification-page-filter-select">
                    <MenuItem value="all">All Types</MenuItem>
                    {TYPE_OPTIONS.map(option => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
                </Select>
            </Grid>
            <Grid item xs={12} sm={3} md={2}>
                <Select variant="outlined" size="small" fullWidth value={statusFilter} onChange={(event) => onStatusFilterChange(event.target.value)} className="notification-page-filter-select">
                    {STATUS_OPTIONS.map(option => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
                </Select>
            </Grid>
            <Grid item xs={12} sm>
                <Box component="button" type="button" className="notification-page-clear-filters" onClick={onClearFilters}>
                    <ClearAllRoundedIcon />
                    Clear filters
                </Box>
            </Grid>
        </Grid>
    </Box>
);

export default NotificationToolbar;
